import React from "react";
import styled from "styled-components";
import SimpleButton from "../buttons/SimpleButton";
import { LeaseMetrics, LicenseMetrics } from "./Metrics";
import { ProjectCosts } from "./ProjectCosts";
import { ComparisonList, Header, SubHeader } from "./Text";

export const ComparisonWrapper = styled.div`
  display: flex;
`;

export const ComparisonItem: React.FC<{
  modelName: string;
  subheaderText: string;
  comparisonListItems: string[];
  pvHardwareLabel?: string;
  pvHardwareCost: number;
  pvInstallationCost: number;
  batteryHardwareLabel?: string;
  batteryCosts?: number;
  enablingWorksCosts: number;
  additionalCosts?: number;
  metrics: JSX.Element;
  setInvestmentModel: () => void;
  currencyCode: string;
}> = ({
  modelName,
  subheaderText,
  comparisonListItems,
  pvHardwareLabel,
  pvHardwareCost,
  pvInstallationCost,
  batteryHardwareLabel,
  batteryCosts,
  enablingWorksCosts,
  additionalCosts,
  metrics,
  setInvestmentModel,
  currencyCode,
}) => {
  return (
    <ComparisonItemWrapper>
      <Header modelName={modelName} />
      <SubHeader text={subheaderText} />
      <ComparisonList listItemTexts={comparisonListItems} />
      {metrics}
      <ProjectCosts
        pvHardwareLabel={pvHardwareLabel!}
        pvHardwareCost={pvHardwareCost}
        pvInstallationCost={pvInstallationCost}
        batteryHardwareLabel={batteryHardwareLabel}
        batteryCosts={batteryCosts}
        enablingWorksCosts={enablingWorksCosts}
        additionalCosts={additionalCosts}
        currencyCode={currencyCode}
      />
      <Footer>
        <SimpleButton
          label={`Select ${modelName}`}
          onClick={setInvestmentModel}
        />
      </Footer>
    </ComparisonItemWrapper>
  );
};

const ComparisonItemWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 8px 16px;
  //padding: 8px 54px;
  margin: 0 8px;
  flex-grow: 1;
`;

const Footer = styled.div`
  margin: 32px 0 16px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const LeaseComparisonItem: React.FC<{
  annualRevenue: number;
  pvHardwareLabel: string;
  batteryHardwareLabel?: string;
  additionalCosts?: number;
  totalBuildingAreaM2: number;
  setInvestmentModel: () => void;
  currencyCode: string;
  areaUnit: string;
}> = ({
  annualRevenue,
  pvHardwareLabel,
  batteryHardwareLabel,
  additionalCosts,
  totalBuildingAreaM2,
  setInvestmentModel,
  currencyCode,
  areaUnit,
}) => {
  const metrics = (
    <LeaseMetrics
      totalBuildingAreaM2={totalBuildingAreaM2}
      annualRevenue={annualRevenue}
      currencyCode={currencyCode}
      areaUnit={areaUnit}
    />
  );
  return (
    <ComparisonItem
      modelName="Lease"
      subheaderText="ZERO up front investment, InRange owns the asset"
      comparisonListItems={[
        "InRange is responsible for all aspects of the operation, maintenance, and distribution of electrons",
        "Landlord provides InRange with the rights to install, operate and maintain the solar panel installation",
        "Landlords receive revenue from rent and profit-share generated from the sale of electrons",
      ]}
      pvHardwareLabel={pvHardwareLabel}
      pvHardwareCost={0}
      pvInstallationCost={0}
      batteryHardwareLabel={batteryHardwareLabel}
      batteryCosts={0}
      enablingWorksCosts={0}
      additionalCosts={additionalCosts}
      metrics={metrics}
      setInvestmentModel={setInvestmentModel}
      currencyCode={currencyCode}
    />
  );
};

export const LicenseComparisonItem: React.FC<{
  irr?: number;
  paybackMonths?: number;
  annualRevenue: number;
  pvHardwareLabel: string;
  pvHardwareCosts: number;
  pvInstallationCosts: number;
  batteryHardwareLabel?: string;
  batteryCosts?: number;
  enablingWorksCosts: number;
  additionalCosts?: number;
  initialInvestment: number;
  setInvestmentModel: () => void;
  currencyCode: string;
}> = ({
  irr,
  paybackMonths,
  annualRevenue,
  pvHardwareLabel,
  pvHardwareCosts,
  pvInstallationCosts,
  batteryHardwareLabel,
  batteryCosts,
  enablingWorksCosts,
  initialInvestment,
  additionalCosts,
  setInvestmentModel,
  currencyCode,
}) => {
  const metrics = (
    <LicenseMetrics
      irr={irr}
      paybackMonths={paybackMonths}
      initialInvestment={initialInvestment}
      annualRevenue={annualRevenue}
      currencyCode={currencyCode}
    />
  );

  return (
    <ComparisonItem
      modelName="License"
      subheaderText="Up front investment, you own the asset"
      comparisonListItems={[
        "InRange is responsible for all aspects of the operation, maintenance, and distribution of electrons",
        "Landlord provides them with the rights to operate and maintain the solar panel installation",
        "Landlords receive revenue from rent and profit-share generated from the sale of electrons",
      ]}
      pvHardwareLabel={pvHardwareLabel}
      pvHardwareCost={pvHardwareCosts}
      pvInstallationCost={pvInstallationCosts}
      batteryHardwareLabel={batteryHardwareLabel}
      batteryCosts={batteryCosts}
      enablingWorksCosts={enablingWorksCosts}
      additionalCosts={additionalCosts}
      metrics={metrics}
      setInvestmentModel={setInvestmentModel}
      currencyCode={currencyCode}
    />
  );
};
